// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled-icon {\n  opacity: 0.5 !important;\n  pointer-events: none !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
